import editorConfig from './editorConfig';

export const getDefaultTextProps = () => {
  const defaultTextProps = {
    text: 'Sample Text',
    color: '#000000',
    opacity: 1,
    fontFamily: editorConfig.defaultFontFamily,
    fontSize: Math.floor(window.canvas.width / 4),
    width: Math.floor(window.canvas.width / 20),
    fontWeight: 'normal',
    fontStyle: 'normal',
    underline: false,
    linethrough: false,
    textAlign: 'left',
    lineHeight: 1,
    charSpacing: 0,
  };

  return defaultTextProps;
};
